var productHandleQueue = getProductHandle();
var productCardMarkup = `
 <ul class="grid grid--uniform grid--view-items">
 {{#products}}
  <li class="grid__item grid__item--collection-template small--one-half medium-up--one-fifth">
    <div class="grid-view-item tbw-product-wrapper product swiper-slide">
      <div class="tbw-product-item">
        <div class="product-item-image">
          <div class="product-image">
            <a href="{{du}}" class="no-hover">
              <img src="{{iu}}" />
            </a>
          </div>
          <div class="product-title" data-url={{du}}>
            <a href="{{du}}">{{title}}</a>
          </div>
        </div>
        <div class="product-item-info">
          <div class="product-price-quantity">
            <div class="price price--listing {{#op }}price--on-sale{{/op}}">
              {{#op}}
                <div class="price__sale">
                  <dt>
                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  </dt>
                  <dd>
                    <span class="price-item price-item--sale"><span>$</span>{{pr}}</span>
                  </dd>
                  <div class="price__compare">
                    <dt>
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    </dt>
                    <dd>
                      <s class="price-item price-item--regular">
                      <span>$</span>{{op}}
                      </s>
                    </dd>
                  </div>
                </div>
              {{/op}}
              {{^op}}
                <div class="price__regular">
                  <dt>
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  </dt>
                  <dd>
                    <span class="price-item price-item--regular"><span>$</span>{{pr}}</span>
                  </dd>
                </div>
              {{/op}}
            </div>
            <div class="quantity quantity-wrapper-event">
              <span class="icon minus">
              </span>
              <input type="number"
                name="quantity" value="1" min="1" pattern="[0-9]*"
                class="product-form__input product-form__input--quantity" 
              >
              <span class="icon plus">
              </span>
            </div>
          </div>
          <div class="product-item-button">
            <button class="btn product-add-to-cart" data-currentvariant="{{epi}}" data-product-id="{{empi}}">
              <div class="lds-dual-ring add-to-card-loading"></div>
              <span class="product-action-button">Add to cart</span>
            </button>
          </div>
        </div>
        <div class="wishlist-action">
          <a class="remove">Remove</a>
          <i class="fal fa-times"></i>
        </div>
      </div>
    </div>
  </li>
  {{/products}}
 </ul>
`;

function getVariantInfo(variants){
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
    if(variantKeys.length > 0){
      variantinfo = variantKeys[0];
      if(variantinfo == "Default Title"){
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch(err){
    return variants;
  }
}

function initEvent(){
  removeItemWishlist();
  fetchData();
}

function removeItemWishlist(){
  $(document).on('click','.wishlist-action',function(e){
    var $container = $(e.target).closest('.grid__item.grid__item--collection-template');
    var productId = $container.find('.product-item-button .btn').data('productId');
    var variantId = $container.find('.product-item-button .btn').data('currentvariant');
    var url = $container.find('.product-title').data('url');
    window._swat.removeFromWishList(
      {
        "epi": variantId,
        "du": url,
        "empi": productId,
      },
      function(r) {
        $container.remove();
        var wishlistData = JSON.parse(localStorage.getItem('swym-products'));
        wishlistData.all.forEach(function(element,index) {
          if (element.epi == variantId) {
            wishlistData.all.splice(index,1);
            return false;
          }
        });
        localStorage.setItem('swym-products',JSON.stringify(wishlistData));
      }
    );
  });
}

function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("Collection");
  _swat.fetchWrtEventTypeET(
    function(products) {
      // Get wishlist items
      
      var formattedWishlistedProducts = products.map(function(p){
        p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
        return p;
      });
      console.log(formattedWishlistedProducts);
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      
    },
    window._swat.EventTypes.addToWishlist
  );
}

function align(selector,n,k,minHeight){
  for(var i =(n-k);i<n;i++){
    $(selector).eq(i).css('height', minHeight);
  }
}

function alignHeights(selector,k){
  var length = $(selector).length;
  var n = k;
  for(var i = 0;i < length;i+=k){
    var minHeight = $(selector).eq(n-k).outerHeight();
    for(var j = (n-k);j< n;j++){
      if(j < (n-1)){
        if(minHeight <  $(selector).eq(j+1).outerHeight())
        {
          minHeight = $(selector).eq(j+1).outerHeight();
        }
      }
      if(j == (n-1)){
        align(selector,n,k,minHeight);
      }
    }
    n += k;
  }
}

function getProductHandle(){
  var productHandle = JSON.parse(localStorage.getItem("swym-products"));
  var productHandleQueue = [];
  for(var i = 0;i<productHandle.all.length;i++){
    var start = productHandle.all[i].du.lastIndexOf("/");
    var end = productHandle.all[i].du.length;
    var handle ="/products"+productHandle.all[i].du.slice(start,end)+".js";
    if(!productHandleQueue.includes(handle)){
      productHandleQueue.push(handle);
    }
  }
  return productHandleQueue || [];
}

function fetchData() {
  if (productHandleQueue.length) {
    jQuery.ajax({
      dataType: 'json',
      url:productHandleQueue[0],
      success: function(product) {
        var {available,variants,price,images,title,url,compare_at_price,id} = product;
        var sale = (compare_at_price != null ) ? 'price--on-sale' : ''
        price = Shopify.formatMoney(product.price);
        var salePrice = Shopify.formatMoney(product.compare_at_price);
        var productId = id;
        var currentVariant = variants[0].id;
        productHandleQueue.shift();
        var productCardMarkup = `
        <li class="grid__item grid__item--collection-template small--one-half medium-up--one-fifth">
          <div class="grid-view-item tbw-product-wrapper product swiper-slide">
            <div class="tbw-product-item">
              <div class="product-item-image">
                <div class="product-image">
                  <a href="${url}" class="no-hover">
                    <img src="${images}" />
                  </a>
                </div>
                <div class="product-title" data-url=${url}>
                  <a href="${url}">${title}</a>
                </div>
              </div>
              <div class="product-item-info">
                <div class="product-price-quantity">
                  <div class="price price--listing ${sale}">
                  ${ compare_at_price != null
                    ? `<div class="price__sale">
                        <dt>
                          <span class="visually-hidden visually-hidden--inline">Sale price</span>
                        </dt>
                        <dd>
                          <span class="price-item price-item--sale">${price}</span>
                        </dd>
                        <div class="price__compare">
                          <dt>
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          </dt>
                          <dd>
                            <s class="price-item price-item--regular">
                            ${salePrice}
                            </s>
                          </dd>
                        </div>
                      </div>`
                    : `<div class="price__regular">
                        <dt>
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        </dt>
                        <dd>
                          <span class="price-item price-item--regular">${price}</span>
                        </dd>
                      </div>`
                    } 
                  </div>
                  <div class="quantity quantity-wrapper-event">
                    <span class="icon minus">
                    </span>
                    <input type="number"
                      name="quantity" value="1" min="1" pattern="[0-9]*"
                      class="product-form__input product-form__input--quantity" 
                    >
                    <span class="icon plus">
                    </span>
                  </div>
                </div>
                <div class="product-item-button">
                  ${ !!available
                    ? `<button class="btn product-add-to-cart" data-currentvariant="${currentVariant}" data-product-id="${productId}">
                        <div class="lds-dual-ring add-to-card-loading"></div>
                        <span class="product-action-button">Add to cart</span>
                      </button>
                      `
                    : `<button class="btn" aria-label="Sold out" data-currentvariant="${currentVariant}" data-product-id="${productId}">
                        <span class="product-action-button">Sold out</span>
                      </button>`
                  }
                </div>
              </div>
              <div class="wishlist-action">
                <a class="remove">Remove</a>
                <i class="fal fa-times"></i>
              </div>
            </div>
          </div>
        </li>
        `;
        $('.cms-wishlist .category-product ul.grid.grid--uniform.grid--view-items').append(productCardMarkup);
        fetchData();
      },
      error: function() {
        productHandleQueue.shift();
        fetchData();
      }
    });
  }else{
    $('.cms-wishlist .category-product').removeClass('three-3-dots')
    var width = $(window).width();
    if(width < 768){
      alignHeights('.cms-wishlist .category-product .product-item-info .product-price-quantity',2);
    }else if(width < 1366){
      alignHeights('.cms-wishlist .category-product .product-item-info .product-price-quantity',4);
    }else{
      alignHeights('.cms-wishlist .category-product .product-item-info .product-price-quantity',5);
    }
    $(window).on('resize',function(){
      if(width < 768){
        setTimeout(function(){
          alignHeights('.cms-wishlist .category-product .product-item-info .product-price-quantity',2);
        },500);
      }else if(width < 1366){
        setTimeout(function(){
          alignHeights('.cms-wishlist .category-product .product-item-info .product-price-quantity',4);
        },500);
      }else{
        setTimeout(function(){
          alignHeights('.cms-wishlist .category-product .product-item-info .product-price-quantity',5);
        },500);
      }
    })
  }
};

if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
//window.SwymCallbacks.push(swymCallbackFn);
window.SwymCallbacks.push(initEvent);
